<div class="fc-contact-language">
    <fc-dropdown-component [disabled]="disabled">
        <fc-dropdown-toggle
            [ngClass]="{ 'fc-contact-language-disabled': disabled }"
            [direction]="dropdownDirection"
            [disabled]="disabled"
        >
            <span class="flag-icon" [ngClass]="'flag-icon-' + currentLanguage.flag"></span>
            <span>{{ currentLanguage.name }}</span>
        </fc-dropdown-toggle>
        <fc-dropdown-menu [direction]="dropdownDirection">
            <li class="fc-filter-dropdown-item" *ngFor="let language of selectableLanguages">
                <a class="fc-dropdown-menu-item" (click)="selectLanguage(language)">
                    <span class="flag-icon flag-icon-{{ language.flag }}">{{ language.name }}</span>
                </a>
            </li>
        </fc-dropdown-menu>
    </fc-dropdown-component>
</div>
